const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20fantasy%20movie%20scene%20with%20dramatic%20lighting%2C%20warriors%20in%20ancient%20armor%2C%20cinematic%20composition%2C%20warm%20golden%20and%20red%20tones%2C%20movie%20poster%20style%2C%20rich%20textures%2C%20dark%20atmospheric%20background&width=800&height=500&seq=carousel-dsxy-01&orientation=landscape',
    tag: '暑期档专题',
    title: '2026暑期档观影指南',
    desc: '院线大片 + 平台独播，这份片单让你整个夏天不剧荒',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20series%20visual%20with%20city%20night%20scene%2C%20warm%20neon%20lights%2C%20cinematic%20poster%20style%2C%20mysterious%20atmosphere%2C%20film%20noir%20aesthetic%2C%20rich%20dark%20tones%20with%20amber%20highlights&width=800&height=500&seq=carousel-dsxy-02&orientation=landscape',
    tag: '悬疑专场',
    title: '烧脑悬疑剧精选',
    desc: '高口碑悬疑剧合集，反转不断让你停不下来',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20art%20style%20with%20mythological%20elements%2C%20ink%20wash%20painting%20aesthetic%2C%20fantasy%20creatures%2C%20ethereal%20lighting%2C%20cinematic%20composition%2C%20dark%20background%20with%20golden%20and%20crimson%20accents&width=800&height=500&seq=carousel-dsxy-03&orientation=landscape',
    tag: '国漫崛起',
    title: '国产动画巅峰之作',
    desc: '从《大圣归来》到《深海》，见证国漫的华丽蜕变',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20nostalgic%20style%20with%20vintage%20film%20texture%2C%20martial%20arts%20movie%20aesthetic%2C%20warm%20sepia%20tones%2C%20cinematic%20composition%2C%20dark%20background%20with%20golden%20highlights%2C%20premium%20film%20photography&width=800&height=500&seq=carousel-dsxy-04&orientation=landscape',
    tag: '经典重温',
    title: '港片黄金年代回顾',
    desc: '周星驰、成龙、王家卫，那些年我们追过的港片经典',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=International%20film%20festival%20award%20winning%20movies%20visual%20with%20artistic%20cinematography%2C%20golden%20statue%20trophy%2C%20red%20carpet%20atmosphere%2C%20elegant%20dark%20background%2C%20premium%20cinema%20aesthetic%2C%20dramatic%20spotlight%20effects&width=800&height=500&seq=carousel-dsxy-05&orientation=landscape',
    tag: '获奖佳作',
    title: '国际电影节获奖作品',
    desc: '戛纳、威尼斯、柏林，三大电影节获奖影片一次看够',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-950 dark-section">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-white mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            精心策划的影视专题合集，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-[4/5] bg-background-900"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block bg-primary-500 text-white text-[10px] font-semibold px-2.5 py-1 rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-white font-heading font-bold text-sm md:text-base mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-white/50 text-[11px] md:text-xs line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* View all link */}
        <div className="text-center mt-8 md:mt-10">
          <a
            href="#index"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium cursor-pointer"
          >
            查看全部专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}